import React from 'react';
import loadable from '@loadable/component';
import LazyLoader from 'react-lazyload';
import { useSelector } from 'react-redux';
import { ErrorBoundary } from '@browsing/components';
import { useConfig } from '@browsing/config';

import { getClientDeviceHeight, getWebviewOs } from '@client/redux/modules/clientDevice';

const LazyFooter = loadable(() => import(/* webpackChunkName: "footer" */ '@browsing/footer'));

const FooterWrapper = () => {
    const config = useConfig();

    const deviceHeight = useSelector(getClientDeviceHeight);
    const isWebView = !!useSelector(getWebviewOs);
    if (!config.isEnabled('footer')) {
        return null;
    }

    return (
        <ErrorBoundary componentName="footer">
            <LazyLoader offset={deviceHeight * 2} once>
                <LazyFooter isWebView={isWebView} locale={config.localeCode} />
            </LazyLoader>
        </ErrorBoundary>
    );
};

export default FooterWrapper;
